module.exports = __webpack_public_path__ + "website/img/jg.b3d0791a.svg";